import React from 'react';

import LoginFormApp from '../../Teacher/components/accounts/login/login_form.jsx';
import DemoAccountContextProvider from '../../Teacher/contexts/DemoAccountContextProvider';

export default ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <LoginFormApp {...props} />
  </DemoAccountContextProvider>
);
